import { useParams } from 'react-router-dom';
import Vimeo from '@u-wave/react-vimeo';



export const VimeoComponent = () => {
    const { videoId } = useParams();


const videoPlay = () => {
     //console.log('se reprodujo un video')
};

const videoEnd = () => {
    //console.log('se terminó el video')
};

  return (
    <Vimeo
    video={videoId}
    autoplay
    onPlay={videoPlay}
    onEnd={videoEnd}
    dnt={false}
  />
  )
}
